import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, Signal, signal } from '@angular/core';
import { Router } from '@angular/router';
import packageJson from '@package';
import { APP_CONFIG, CurrentLanguageSignalService, DocumentsService } from '@klubovna/shared-data';
import { contactInfo, DocumentItem, menuItems, MenuItem } from '@klubovna/shared-models';
import { SharedModule } from '../../shared.module';
import { BaseScreenComponent } from '../base-screen/base-screen.component';

@Component({
  selector: 'k-footer',
  imports: [ SharedModule, DatePipe ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  providers: [ CurrentLanguageSignalService ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent extends BaseScreenComponent {
  private currentLanguage: CurrentLanguageSignalService = inject(CurrentLanguageSignalService);
  private router: Router = inject(Router);
  private documentsService: DocumentsService = inject(DocumentsService);
  private appConfig = inject(APP_CONFIG);

  public version: string = packageJson.version;
  contactInfo = contactInfo;

  menuItems: Signal<MenuItem[]> = signal(menuItems);
  languageButtonLabelSig: Signal<'en' | 'sk'> = this.currentLanguage.languageButtonLabelSig;
  currentDate: Signal<Date> = signal(new Date());
  documentsSig = this.documentsService.documentsSig;
  documentsLoadingSig = this.documentsService.documentsLoadingSig;

  bgColorSig = input<string>('bg-night');

  navigateOrScroll(menuItem: MenuItem, label?: string): void {
    if (label) {
      this.gtagService.trackEvent('Button', 'Click', label + menuItem.id);
    }

    if (menuItem?.scrollToBottom) {
      this.scrollToBottom();
      return;
    }

    if (menuItem?.consoleApp && menuItem.routerLink) {
      if (typeof window !== 'undefined') {
        window.location.href = `${ this.appConfig.consoleUrl ?? '' }${ menuItem.routerLink }`;
      }
      return;
    }

    if (menuItem?.routerLink) {
      this.router.navigate([ menuItem.routerLink as string ]);
      return;
    }

    if (menuItem.link) {
      if (typeof window !== 'undefined') {
        window.open(menuItem.link, '_blank');
      }
    }
  }

  getDocumentPath(doc: DocumentItem): string {
    return this.languageButtonLabelSig() === 'en' && doc.pathEn ? doc.pathEn : doc.path;
  }

  getDocumentName(doc: DocumentItem): string {
    return this.languageButtonLabelSig() === 'en' && doc.nameEn ? doc.nameEn : doc.name;
  }
}
